import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { landingPageStoreKey } from '../feature/landing-page.feature';
import { LandingPage, LandingPageState } from '../state/landing-page.state';

export const getLandingPageState =
  createFeatureSelector<LandingPage>(landingPageStoreKey);

export const getMobileNavigationMenu = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.mobileNavigationMenu,
);

export const getDesktopNavigationMenu = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.desktopNavigationMenu,
);

export const getActiveSignButton = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.activeSignButton,
);

export const getSignInDetails = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.signInResponse,
);

export const getSignUpDetails = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.signUpResponse,
);

export const getIsPasswordUpdated = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.isPasswordUpdated,
);

export const getIsOTPRequested = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.isOTPRequested,
);

export const getContactUsRequestStatus = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.contactUsRequestStatus,
);

export const getSignInRequestStatus = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.signInRequestStatus,
);

export const getSignUpRequestStatus = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.signUpRequestStatus,
);

export const getRequestOTPRequestStatus = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.requestOTPRequestStatus,
);

export const getChangePasswordRequestStatus = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.changePasswordRequestStatus,
);

export const getReactivateKey = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.reactivateKey,
);

export const getReactivateAccountResponse = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.reactivateAccountResponse,
);

export const getReactivateAccountRequestStatus = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.reactivateAccountRequestStatus,
);

export const getReactivateAccountErrorMessage = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.reactivateAccountErrorMessage,
);

@Injectable({
  providedIn: 'root',
})
export class LandingPageSelectors {
  getMobileNavigationMenu$ = this.store.select(getMobileNavigationMenu);
  getDesktopNavigationMenu$ = this.store.select(getDesktopNavigationMenu);
  getActiveSignButton$ = this.store.select(getActiveSignButton);
  getSignInDetails$ = this.store.select(getSignInDetails);
  getSignUpDetails$ = this.store.select(getSignUpDetails);
  getIsPasswordUpdated$ = this.store.select(getIsPasswordUpdated);
  isOTPRequested$ = this.store.select(getIsOTPRequested);
  contactUsRequestStatus$ = this.store.select(getContactUsRequestStatus);
  signInRequestStatus$ = this.store.select(getSignInRequestStatus);
  signUpRequestStatus$ = this.store.select(getSignUpRequestStatus);
  requestOTPRequestStatus$ = this.store.select(getRequestOTPRequestStatus);
  changePasswordRequestStatus$ = this.store.select(
    getChangePasswordRequestStatus,
  );
  reactivateKey$ = this.store.select(getReactivateKey);
  reactivateAccountResponse$ = this.store.select(getReactivateAccountResponse);
  reactivateAccountRequestStatus$ = this.store.select(
    getReactivateAccountRequestStatus,
  );
  reactivateAccountErrorMessage$ = this.store.select(
    getReactivateAccountErrorMessage,
  );

  constructor(private store: Store<LandingPageState>) {}
}
